import React from "react"; // מייבא את React כדי להגדיר קומפוננטה

// קומפוננטת עמוד "מדיניות פרטיות" מלאה, מוכנה להדבקה
export default function PrivacyPolicy() { // מייצא את הקומפוננטה כברירת מחדל
  const lastUpdated = new Date().toLocaleDateString("he-IL"); // תאריך עדכון דינמי בפורמט עברי
  var mail = 'NfigHelp@gmail.com'
  return ( // מתחיל להחזיר JSX
    <main dir="rtl" lang="he" className="nfig-legal my-10 space-y-6"> {/* מיכל ראשי לימין עם ריווח */}
      <header className="space-y-1"> {/* כותרת עליונה של העמוד */}
        <h1 className="text-3xl font-bold">מדיניות פרטיות</h1> {/* כותרת ראשית */}
        <p className="text-sm text-gray-500">תאריך עדכון אחרון: {lastUpdated}</p> {/* הצגת תאריך עדכני */}
      </header>

      <section className="space-y-2"> {/* סעיף: מי אנחנו */}
        <h2 className="text-xl font-semibold">מי אנחנו</h2> {/* כותרת סעיף */}
        <p>
          <strong>[שם העסק]</strong> (“אנחנו”, “האתר”) — <strong>[עוסק/ח.פ]</strong>, דוא״ל: <strong>[{mail}]</strong>.
        </p> {/* פרטי ישות עסקית — יש להחליף במידע בפועל */}
      </section>

      <section className="space-y-2"> {/* סעיף: כללי */}
        <h2 className="text-xl font-semibold">1. כללי</h2> {/* כותרת סעיף */}
        <p>
          מדיניות זו מסבירה איזה מידע אנו אוספים, כיצד אנו משתמשים בו, עם מי אנו משתפים אותו ומהן הזכויות שלך. השימוש באתר מהווה הסכמה למדיניות זו.
        </p> {/* ניסוח כללי למדיניות */}
      </section>

      <section className="space-y-2"> {/* סעיף: איסוף מידע */}
        <h2 className="text-xl font-semibold">2. איזה מידע אנו אוספים</h2> {/* כותרת סעיף */}
        <ul className="list-disc pr-5 space-y-1"> {/* רשימת נקודות */}
          <li>
            <strong>מידע שנמסר על‑ידך:</strong> שם, דוא״ל, טלפון, כתובת משלוח, פרטי הזמנה, פניות לשירות לקוחות ותוכן טפסים.
          </li> {/* מידע שמוזן ידנית */}
          <li>
            <strong>מידע אוטומטי:</strong> כתובת IP, מזהי קוקיות/מכשיר, נתוני דפדפן ומערכת הפעלה, עמודים שנצפו, זמני כניסה וקישורי הפניה.
          </li> {/* מידע טכני */}
          <li>
            <strong>תשלומים:</strong> סליקה מטופלת אצל ספק/ית תשלומים (למשל,PayPal/ישראכרט). איננו שומרים אצלנו פרטי כרטיס אשראי מלאים.
          </li> {/* הבהרה לגבי אמצעי תשלום */}
         {/* <li>
            <strong>Cookies וטכנולוגיות דומות:</strong> לצורך הפעלה, אבטחה, אנליטיקה, התאמה אישית ושיווק מחדש. ניתן לנהל העדפות בדפדפן או בבאנר קוקיות באתר (אם קיים).
          </li>  שימוש בעוגיות */}
        </ul>
      </section>

      <section className="space-y-2"> {/* סעיף: מטרות עיבוד */}
        <h2 className="text-xl font-semibold">3. למה אנו משתמשים במידע (מטרות העיבוד)</h2> {/* כותרת סעיף */}
        <ul className="list-disc pr-5 space-y-1"> {/* רשימת נקודות */}
          <li>ניהול חשבונות והזמנות, אספקת שירות ותמיכה.</li> {/* מטרה 1 */}
          <li>שיפור האתר והחוויה, מדידה וניתוח ביצועים.</li> {/* מטרה 2 */}
          <li>שליחת עדכוני הזמנה, התראות שירות ותוכן שיווקי בהסכמה (Opt‑in).</li> {/* מטרה 3 */}
          <li>עמידה בחובות חוקיות וציות לדרישות רשויות.</li> {/* מטרה 4 */}
        </ul>
      </section>

      <section className="space-y-2"> {/* סעיף: בסיס משפטי */}
        <h2 className="text-xl font-semibold">4. הבסיס המשפטי (כאשר חל ה‑GDPR/דין אירופי)</h2> {/* כותרת סעיף */}
        <ul className="list-disc pr-5 space-y-1"> {/* רשימת נקודות */}
            <li>ביצוע חוזה (למשל טיפול בהזמנה).</li> {/* בסיס 1 */}
            <li>אינטרס לגיטימי (למשל שיפור השירות, אבטחה ומניעת הונאה).</li> {/* בסיס 2 */}
            <li>הסכמה (למשל דיוור שיווקי או קוקיות לא חיוניות).</li> {/* בסיס 3 */}
            <li>חובה חוקית (שמירת מסמכים חשבונאיים וכד’).</li> {/* בסיס 4 */}
        </ul>
      </section>

      <section className="space-y-2"> {/* סעיף: שיתוף מידע */}
        <h2 className="text-xl font-semibold">5. שיתוף מידע עם צדדים שלישיים</h2> {/* כותרת סעיף */}
        <p>אנו עשויים לשתף מידע עם גורמים הבאים, רק ככל הנדרש ומתוך הסכמים לשמירת פרטיות:</p> {/* הסבר כללי */}
        <ul className="list-disc pr-5 space-y-1">
          <li>
            <strong>מעבדי נתונים:</strong> ספקי אחסון/בסיס נתונים (למשל <strong>Supabase</strong>), ספקי תשלומים, משלוחים/לוגיסטיקה, תמיכת לקוחות וכלי אנליטיקה.
          </li> {/* דוגמאות לשותפים */}
          <li>
            <strong>רשויות וגופים אכיפתיים:</strong> אם נידרש לפי חוק או לשם הגנה על זכויותינו.
          </li> {/* מסירת מידע לרשויות */}
        </ul>
      </section>

      <section className="space-y-2"> {/* סעיף: שמירת מידע */}
        <h2 className="text-xl font-semibold">6. שמירת מידע</h2> {/* כותרת סעיף */}
        <p>
          נשמור מידע למשך הזמן הדרוש למטרות שתוארו לעיל (לרבות אחריות, דיווח וציות), ולאחר מכן נמחק או כל פעולה אחרת בכפוף לדין.
        </p> {/* מדיניות שמירה */}
      </section>

      <section className="space-y-2"> {/* סעיף: אבטחה */}
        <h2 className="text-xl font-semibold">7. אבטחה</h2> {/* כותרת סעיף */}
        <p>
          אנו מיישמים אמצעי אבטחת מידע סבירים, לרבות הצפנה ובקרות גישה. עם זאת, אין אבטחה מוחלטת באינטרנט.
        </p> {/* הבהרת אחריות */}
      </section>

      <section className="space-y-2"> {/* סעיף: זכויות נושא המידע */}
        <h2 className="text-xl font-semibold">8. זכויותיך (ישראל/האיחוד האירופי)</h2> {/* כותרת סעיף */}
        <p>
          ייתכן ותהיה זכאי/ת לבקש <strong>עיון, תיקון, מחיקה, הגבלת עיבוד, ניידות נתונים</strong> ולהתנגד לעיבוד מסוים (לרבות שיווק ישיר).
          אם הבסיס לעיבוד הוא הסכמה — ניתן לבטלה בכל עת, מבלי לפגוע בחוקיות עיבוד שכבר בוצע.
        </p> {/* פירוט הזכויות */}
        <p>
          למימוש זכויותיך, ניתן לפנות אלינו בכתובת הדוא״ל המופיעה בסעיף "יצירת קשר" מטה.
        </p> {/* ערוץ פנייה */}
      </section>

      <section className="space-y-2"> {/* סעיף: העברות בינלאומיות */}
        <h2 className="text-xl font-semibold">9. העברות בינלאומיות</h2> {/* כותרת סעיף */}
        <p>
          ייתכן שמידע יאוחסן/יעובד מחוץ לישראל. כאשר נדרש, נוודא מנגנוני הגנה הולמים (כגון סעיפים חוזיים סטנדרטיים).
        </p> {/* הבהרה לגבי טרנספר בינלאומי */}
      </section>

      <section className="space-y-2"> {/* סעיף: קטינים */}
        <h2 className="text-xl font-semibold">10. קטינים</h2> {/* כותרת סעיף */}
        <p>
          האתר אינו מיועד לילדים מתחת לגיל 16 ללא הסכמת הורה/אפוטרופוס. אם התגלה שנאסף מידע מקטין, אנא פנו אלינו למחיקה.
        </p> {/* מדיניות לגבי קטינים */}
      </section>

      <section className="space-y-2"> {/* סעיף: שינויים */}
        <h2 className="text-xl font-semibold">11. שינויים במדיניות</h2> {/* כותרת סעיף */}
        <p>
          נעדכן מדיניות זו מעת לעת. הגרסה העדכנית תתפרסם בדף זה ותצוין למעלה תחת "תאריך עדכון אחרון".
        </p> {/* מנגנון עדכון */}
      </section>

      <section className="space-y-2"> {/* סעיף: יצירת קשר */}
        <h2 className="text-xl font-semibold">12. יצירת קשר</h2> {/* כותרת סעיף */}
        <address className="not-italic"> {/* תגית כתובת ללא נטוי */}
          דוא״ל: {mail}
        </address> {/* פרטי קשר — יש להחליף */}
      </section>
    </main>
  ); // סוף JSX
} // סוף הקומפוננטה
